import usConfig from './us.config';
import canadaConfig from './canada.config';
import richmondConfig from './richmond.config';

const config = {};
switch (process.env.VUE_APP_COUNTRY) {
  case 'us':
    Object.assign(config, usConfig);
    break;
  case 'canada':
    Object.assign(config, canadaConfig);
    break;
  case 'richmond':
    Object.assign(config, richmondConfig);
    break;
  default:
    break;
}

export default config;
